import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const Container = styled.div<{ $isSent: boolean | null; $img?: string }>`
  //if form is sent, set first and second items to display: none
  ${({ $isSent }) =>
    $isSent
      ? `
    display: grid;
    gap: calc(${space('x10')} + ${space('md')});
    align-items: center;
    justify-content: center;
    padding: 64px 64px 64px calc(72px);
    @media screen and (${query.below('tablet')}) {
      grid-template-columns: 1fr;
      gap: ${space('x6')};
      padding: ${space('x10')} ${space('xl')};
    }
        > div:nth-child(1) {
          display: none;
        }
      `
      : ''}
`;

export const DisclaimerAndErrorContainer = styled.div<{
  $isStackedImageForm?: boolean;
}>`
  height: ${({ $isStackedImageForm }) => $isStackedImageForm && '350px'};
  ${({ $isStackedImageForm }) =>
    $isStackedImageForm &&
    `@media (max-width: 1265px) {
      height: auto;
      margin-bottom: 14px;
    }
    @media (max-width: 900px) {
      height: auto;
    }
  };`}

  @media screen and (${query.below('tablet')}) {
    margin-top: 20px;
    margin-bottom: 30px;
    height: ${({ $isStackedImageForm }) => !$isStackedImageForm && 'unset'};
  }
`;

export const DisclaimerContainer = styled.div<{
  $isStackedImageForm?: boolean;
}>`
  display: flex;
  gap: 8px;
  margin-top: ${({ $isStackedImageForm }) => ($isStackedImageForm ? '6px' : '14px')};
  .ant-checkbox-inner {
    height: 20px;
    width: 20px;
  }
`;

export const DisclaimerText = styled.div<{ $isStackedImageForm?: boolean }>`
  color: #404040;
  ${font('body-sm')};
  letter-spacing: 0.35px;
  line-height: 24px;
`;

export const ReadMore = styled.div`
  ${font('body-sm')};
  color: #404040;
  display: block;
  line-height: 22px;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  margin-top: 8px;
`;

export const GridTopContainer = styled.div`
  margin: auto;
  width: 575px;
  padding-right: 20px;
  padding-left: 20px;

  @media screen and (${query.below('desktop')}) {
    width: unset;
  }
`;

export const ContactDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${space('x5')} ${space('x6')};
`;

export const Header = styled.h2<{ $isSent?: boolean }>`
  ${({ $isSent }) => (!$isSent ? font('body-xs') : font('headline-sm'))};
  ${({ $isSent }) => ($isSent ? 'auto' : '0')}
  margin: 16px 0 32px;
  font-weight: ${({ $isSent }) => $isSent && '700'};
  font-size: ${({ $isSent }) => $isSent && '40px'};
  letter-spacing: ${({ $isSent }) => !$isSent && '2px'};
  color: ${({ $isSent }) => !$isSent && '#666666'};
  padding: 0;
  text-align: center;
  margin-bottom: ${({ $isSent }) => $isSent && '15px'};
  @media screen and (${query.below('tablet')}) {
    font-size: ${({ $isSent }) => !$isSent && '12px'};
    font-weight: ${({ $isSent }) => ($isSent ? '700' : '400')};
  }
`;

export const Text = styled.div<{ $isSent?: boolean }>`
  color: ${color('fg')};
  ${({ $isSent }) => ($isSent ? font('body-md-light') : font('headline-sm'))};
  text-align: center;
  @media screen and (${query.below('tablet')}) {
    ${({ $isSent }) => ($isSent ? font('body-sm-light') : font('headline-xs'))};
    font-size: ${({ $isSent }) => !$isSent && '28px'};
  }
`;

export const FormFinished = styled.div`
  text-align: center;
  overflow: hidden;
  @media screen and (${query.atLeast('tablet')}) {
    padding: 40px 20px;
  }
`;

export const DesktopHeader = styled.div``;
export const FieldWrapperDashboard = styled.div`
  flex: 0 0 100%;
  max-width: 100%;

  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
  }
  textarea {
    display: block;
  }
`;
export const FieldWrapper = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  padding-bottom: 8px;
  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const CustomButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  button {
    font-weight: 400;
    display: flex;
    justify-content: center;
    width: 205px;
    margin-bottom: 64px;
  }

  @media screen and (${query.below('tablet')}) {
    width: 100%;
    button {
      width: 100%;
      border-radius: 4px;
    }
  }
`;

export const StyledForm = styled.form<{ $gutterWidth: boolean; $isStackedImageForm?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: ${({ $gutterWidth, $isStackedImageForm }) =>
    !$isStackedImageForm ? space('x5') : $gutterWidth ? space('x7') : space('md')};

  &:last-child {
    gap: ${({ $isStackedImageForm }) => $isStackedImageForm && space('x5')};

    @media screen and (${query.atLeast('max')}) {
      ${FieldWrapper} {
        &:nth-child(1),
        &:nth-child(2) {
          ${({ $isStackedImageForm }) =>
            $isStackedImageForm && `flex: 0 0 calc(50% - 6px); // half of gap: ${space('md')}`};
        }
      }
    }

    @media screen and (${query.atLeast('tablet')}) {
      ${FieldWrapper} {
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          ${({ $isStackedImageForm }) =>
            !$isStackedImageForm && `flex: 0 0 calc(50% - 12px); // half of gap: ${space('md')}`};
        }
      }
    }
  }

  @media screen and (${query.below('tablet')}) {
    gap: ${({ $gutterWidth }) => ($gutterWidth ? space('x6') : space('md'))};
    button {
      width: 100%;
    }
  }
`;
